import { gql } from '@apollo/client';

export default gql`
  query journeySearchForExchange(
    $reference: String!
    $intention: String!
    $exchangeItems: [Int]
    $outboundDate: String
    $inboundDate: String
    $origin: String!
    $destination: String!
    $returningOrigin: String
    $returningDestination: String
    $passengersList: [InputPassengerBrief]
    $currency: String
    $isSwapStations: Boolean
    $isBPNonFlexOutboundExchange: Boolean
    $isBPNonFlexInboundExchange: Boolean
    $isMissedDeparture: Boolean
    $summatedFares: InputSummatedFares
    $applySummatedFaresMaxTransferRules: Boolean = false
    $multipleFlexibility: Boolean = false
    $isYouthAdultConversionActive: Boolean
    $maxTransfers: Int
    $offerSummatedFares: Boolean = false
    $useNewLoyaltySystem: Boolean
    $productFamilies: [String]
  ) {
    journeySearchForExchange(
      reference: $reference
      intention: $intention
      exchangeItems: $exchangeItems
      outboundDate: $outboundDate
      inboundDate: $inboundDate
      origin: $origin
      destination: $destination
      returningOrigin: $returningOrigin
      returningDestination: $returningDestination
      passengersList: $passengersList
      currency: $currency
      isSwapStations: $isSwapStations
      isBPNonFlexOutboundExchange: $isBPNonFlexOutboundExchange
      isBPNonFlexInboundExchange: $isBPNonFlexInboundExchange
      isMissedDeparture: $isMissedDeparture
      summatedFares: $summatedFares
      applySummatedFaresMaxTransferRules: $applySummatedFaresMaxTransferRules
      multipleFlexibility: $multipleFlexibility
      isYouthAdultConversionActive: $isYouthAdultConversionActive
      maxTransfers: $maxTransfers
      offerSummatedFares: $offerSummatedFares
      useNewLoyaltySystem: $useNewLoyaltySystem
      productFamilies: $productFamilies
    ) {
      outbound {
        ...exchangeOffer
      }
      inbound {
        ...exchangeOffer
      }
      passengers {
        id
        type
        birthDate
        disabilityType
      }
      productFamiliesWithFares @client
    }
  }
  fragment exchangeOffer on Offer {
    totalPriceOfOriginalExchangeItems
    isWheelchair
    origin {
      uic
      name
    }
    destination {
      uic
      name
    }
    productFamilies {
      name
      code
      familyGroup
      familyGroupName
    }
    classesOfService {
      code
      name
    }
    journeys {
      timing {
        departs
        arrives
        duration
        departureDate
        arrivalDate
      }
      fares {
        buckets {
          code
          price
          passengerType
          availability
          physicalAvailability
          highestBucketCodeLogicalAvailability
        }
        legs {
          serviceName
          trainNumber
          serviceIdentifier
          serviceType {
            name
            code
            brandCode
          }
          origin {
            name
            uic
          }
          destination {
            name
            uic
          }
          timing {
            departureDate
            arrivalDate
            departs
            arrives
            duration
          }
          addOnProducts {
            name
            passengerId
            tariffCode
            bucketCode
            code
            price
            originalPrice
            physicalAvailability
            inventoryUnits
            availabilityOfClassOfService
          }
          products {
            name
            isFareAddOn
            passengerId
            tariffCode
            bucketCode
            code
            loyaltyPoints
            price
            originalPrice
          }
          classOfService {
            code
            name
          }
        }
        offlineFee @client
        isLyria @client
        isSummatedFare
        isThroughFare
        fees {
          tariffCode
          price
          name
          passengerId
          code
        }
        productFamily {
          code
          name
          familyGroup
          familyGroupName
        }
        classOfService {
          code
          name
        }
        canBeBooked
        canLoyaltyFareBeExchangedToBP
        prices {
          displayPrice
        }
        promo {
          type
          value
        }
        bookingItems {
          passengerId
          tariffCode
          price
          loyaltyPoints
        }
      }
    }
  }
`;
